/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PromotionCampaignProgressStatus = {
    _11184809: '11184809',
    EXPIRED: 'EXPIRED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    unknown_default_open_api: '11184809'
} as const;
export type PromotionCampaignProgressStatus = typeof PromotionCampaignProgressStatus[keyof typeof PromotionCampaignProgressStatus];


export function instanceOfPromotionCampaignProgressStatus(value: any): boolean {
    for (const key in PromotionCampaignProgressStatus) {
        if (Object.prototype.hasOwnProperty.call(PromotionCampaignProgressStatus, key)) {
            if (PromotionCampaignProgressStatus[key as keyof typeof PromotionCampaignProgressStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PromotionCampaignProgressStatusFromJSON(json: any): PromotionCampaignProgressStatus {
    return PromotionCampaignProgressStatusFromJSONTyped(json, false);
}

export function PromotionCampaignProgressStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionCampaignProgressStatus {
    return json as PromotionCampaignProgressStatus;
}

export function PromotionCampaignProgressStatusToJSON(value?: PromotionCampaignProgressStatus | null): any {
    return value as any;
}

